<template>
  <div class="user-api-switch">
    <ui-button
      v-for="item in serverList"
      :key="item.value"
      :type="isSelected(item)"
      round
      class="user-api-switch__button py-0 px-2"
      size="sm"
      @click="updateServer(item.value)"
    >
      <span class="user-api-switch__button-text">
        {{ item.label }}
      </span>
    </ui-button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { APP_UK_ADMIN, APP_US_ADMIN } from '@/config/app';
import getDomain from '@/utils/getDomain';
import sameDomain from '@/utils/sameDomain';

export default {
  name: 'UserApiSwitch',

  computed: {
    ...mapState('auth', [
      'accessToken',
      'refreshToken',
    ]),
    ...mapGetters('auth', [
      'expiresInSeconds',
    ]),
    isUs() {
      return sameDomain(window.location.href, APP_US_ADMIN);
    },
    serverList() {
      return [
        {
          label: 'UK',
          value: 'eu',
          isSelected: !this.isUs && this.$apiSwitch.selectedValue === 'eu',
        },
        {
          label: 'UAE',
          value: 'uae',
          isSelected: !this.isUs && this.$apiSwitch.selectedValue === 'uae',
        },
        {
          label: 'USA',
          value: 'us',
          isSelected: this.isUs,
        },
      ];
    },
    selectedServer() {
      return this.serverList.find(({ isSelected }) => isSelected)?.value;
    },
  },

  methods: {
    isSelected(item) {
      return item.isSelected ? 'primary' : '';
    },
    updateServer(value) {
      if (value === this.selectedServer) {
        return;
      }

      const redirectUrl = this.$route.name === 'location-view'
        ? new URL(this.$router.resolve({ name: 'locations' }).href, window.location.origin)
        : new URL(window.location.href.split('?')[0]);

      // Fix hostname
      if (this.isUs) {
        // Switch from US to UAE/UK
        redirectUrl.hostname = getDomain(APP_UK_ADMIN);
      } else if (value === 'us') {
        // Switch from UAE/UK to US
        redirectUrl.hostname = getDomain(APP_US_ADMIN);
      } else {
        // Switch between UAE/UK
        this.$apiSwitch.selected = value;
      }

      // Fix auth
      if (this.isUs || value === 'us') {
        const redirectTo = redirectUrl.pathname;
        redirectUrl.pathname = new URL(this.$router.resolve({ name: 'token' }).href, window.location.origin).pathname;
        redirectUrl.searchParams.set('expiresInSeconds', this.expiresInSeconds);
        redirectUrl.searchParams.set('accessToken', this.accessToken);
        redirectUrl.searchParams.set('refreshToken', this.refreshToken);
        redirectUrl.searchParams.set('apiSwitch', value);
        redirectUrl.searchParams.set('redirectPath', encodeURIComponent(redirectTo));
      }

      window.location = redirectUrl.toString();
    },
  },
};
</script>
